import React, { useRef, useLayoutEffect, useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './AnimatedText.scss';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(ScrollTrigger);

const AnimatedText = ({ text }) => {
   const containerRef = useRef();

   gsap.registerPlugin(useGSAP);
   gsap.registerPlugin(ScrollTrigger);


   useGSAP(() => {

      const letters = containerRef.current.querySelectorAll('.letter');

      gsap.set(letters, {
         opacity: 0,
         y: 40,
         filter: 'blur(10px)',
      });

      gsap.to(letters, {
         scrollTrigger: {
            trigger: containerRef.current,
            start: 'top 30%',
            end: '200% 20%',
            //once: true,
            //markers: true,
            toggleActions: "play reverse play reverse"
         },
         opacity: 1,
         y: 0,
         filter: 'blur(0px)',
         ease: 'power3.out',
         stagger: 0.05,
         duration: 0.25,
      });

   }, {})

    useEffect(() => {
         setInterval(() => {
            ScrollTrigger.refresh()
         }, [1500])
      }, [])

   return (
      <div ref={containerRef} className="text-container-cs">
         {text.split(' ').map((char, index) => (
            <>
               <span key={index} className="letter">
                  {char === ' ' ? '\u00A0' : char}
               </span>
               &nbsp;
            </>
         ))}
      </div>
   );
};

export default AnimatedText;